import { render, staticRenderFns } from "./rpt2401.vue?vue&type=template&id=4e899b6a&"
import script from "./rpt2401.vue?vue&type=script&lang=js&"
export * from "./rpt2401.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports